import { render } from "./HomeDetail.vue?vue&type=template&id=4fe55cdb&scoped=true"
import script from "./HomeDetail.vue?vue&type=script&lang=js"
export * from "./HomeDetail.vue?vue&type=script&lang=js"

import "./HomeDetail.vue?vue&type=style&index=0&id=4fe55cdb&scoped=true&lang=css"

import exportComponent from "C:\\servers\\develope\\coinview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe55cdb"]])

export default __exports__